import { Component, computed, inject, input } from '@angular/core';

import { Store } from '@ngrx/store';

import { CategoryStoreSelectors } from '@era/stores';

@Component({
  selector: 'era-room-number',
  templateUrl: './room-number.container.html',
})
export class RoomNumberComponent {
  private readonly store = inject(Store);

  readonly uniqueId = input.required<string>();

  readonly roomNumber = computed(() => {
    const id = this.uniqueId();
    if (!id) return '';

    const room = this.store.selectSignal(CategoryStoreSelectors.selectCategoryByUniqueId('Room', id))();

    return room?.entity?.displayName ?? '';
  });
}
